<template>
<div class="container-fluid">

<!-- PRODUCT MASTER  -->
<div v-if="type=='A'">

<div class="row">
<div  class="col">

<check-product @createProduct="createProduct()" @update="setProduct" :key="refresh" v-bind:items="items" v-bind:sku="product.sku" v-bind:btn="btn" ></check-product>

  <button @click="$emit('back')" class="btn btn-secondary btn-block">      
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
      RITORNA AL DOCUMENTO
  </button>    
  <div class="card border-info mt-1">
  <h4 class="card-header border-info">
   
    <div v-if="product.productId==0">
      <h4 style="color:black" class="text-center"><strong>REGISTRAZIONE NUOVO PRODOTTO </strong></h4>
    </div>  

    <div v-else>
      <h4 style="color:red" class="text-center"><strong>PRODOTTO ESISTENTE ID [ {{product.productId}} ] </strong> </h4>
    </div>

  </h4>

  <div class="card-body">
    
  
 <div class="btn-toolbar " role="toolbar" aria-label="Toolbar with button groups"> 
  
  <button @click="type='B'" type="button"  data-toggle="tooltip" title="Ricerca prodotto del fornitore." class="btn btn-outline-primary   mr-1 mb-1">
    <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    RICERCA PRODOTTO
  </button> 

  <div class="btn-group btn-group-lg ml-2 mb-1">    
 
 
 
  <div class="btn-group" role="group">
    
    <button id="btnGroupDrop1" type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
      <i class="fas fa-edit mr-2" aria-hidden="true"></i>
      CLASSIFICAZIONE
    </button>

    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
      <a @click="lineModal()" class="dropdown-item" href="#">LINEA</a>
      <a @click="type='C'" class="dropdown-item" href="#">CATEGORIA</a>
    </div>
  </div>


  
  <button @click="setNewProduct()" type="button" data-toggle="tooltip" title="Reset anagrafica prodotto." class="btn btn-outline-primary rounded-sm ml-3">
    <i class="fas fa-trash" aria-hidden="true"></i>
   
  </button> 

</div>
 </div>
    <form name="productMaster" v-on:submit.prevent="submit()">
      <div  class="card bg-light text-dark">
      <div class="card-body">
      <div class="row">

        <!-- SUPPLIER -->
        <div class="col">
          <div class="form-group">
            <supplier-select v-bind:Id="doc.supplierId" v-bind:isActive="false"></supplier-select>
          </div>
        </div>

        <!-- BRAND -->
        <div class="col">          
          <div class="form-group">
            <supplier-brand-select  @update="setBrand" v-bind:_brand="product.brand" v-bind:required="true" v-bind:supplierId="doc.supplierId"></supplier-brand-select>
          </div>
        </div>

        <!-- SKU -->
        <div class="col">
          <div class="form-group">
            <label for="codice"><strong>CODICE PRODOTTO DEL FORNITORE</strong></label>
            <input required v-model = "product.sku" type="text" class="form-control bold" placeholder="" id ="sku" name="sku">            
          </div>
        </div>
        <!-- ROW -->
      </div>
      <!-- CARD BODY -->
      </div>
      <!-- CARD -->
      </div>
      
      <div  class="card bg-light text-dark">
      <div class="card-body">
        <div class="row">
        <div class="col">    

          <!-- LINE MODAL -->
          <div class="col-md-4">
            <line-modal @update="refreshLine" v-bind:supplierId="doc.supplierId"></line-modal>  
          </div>

          <div class="form-group">
            
            <!-- LINE -->
            <line-select :key="lineKey"  @update="setLine" v-bind:Id="product.lineId" v-bind:supplierId="doc.supplierId"></line-select>
            
          
                       
            <!--<a @click="lineModal()" href="#"><small>Crea Nuova</small></a>-->

          </div>
        </div>

        <!-- CATEGORY -->
        <div class="col">    
          <div class="form-group">
            <!--<category-select  :key="categoryKey" v-bind:isActive="true"  v-bind:Id="product.categoryId"  v-bind:required="true" @update="setCategoryId"></category-select>-->
            <category-vue-select :key="categoryKey" @input="setCategoryId" v-bind:props="category"></category-vue-select>
          </div>
        </div>

        <!-- DESCRIPTION -->
        <div class="col">    
        <div class="form-group">
          <label for="descrizione">DESCRIZIONE</label>
          <input  v-model="product.description" type="text" class="form-control bold" placeholder="" id ="descrizione">
        </div>
        </div>
        <!-- ROW -->
        </div>
        <div class="row">
        <div class ="col-sm">  
        <div class="form-group">
        <!-- DEPARTMENT -->
        <department-select :key="departmentKey" v-bind:Id="product.departmentId" @update="setDepartment" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></department-select>
        </div>
            </div>
            <div class ="col-sm">  
              <div class="form-group">
              <!-- SEASON -->
              <season-select :key="seasonKey" @update="setSeason" v-bind:Id="product.seasonId" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></season-select>
                
              </div>

            </div>
            <div class ="col-sm"> 
            <div class="form-group">
              <!-- YEAR -->
              <year-select :key="yearKey" @update="setYear" v-bind:required="true" v-bind:_year="product.season_year" v-bind:isActive="true"></year-select>   
              </div>      


            </div>
          </div>
          
          <div class="row">

          <div class="col-sm">    
          <div class="form-group">
            <label for="composizione">COMPOSIZIONE</label>
            <input  v-model="product.material" type="text" class="form-control bold" placeholder="" id ="material">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">DIMENSIONE</label>
            <input  v-model="product.dimension" type="text" class="form-control bold" placeholder="" id ="dimension">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">MADE IN</label>
            <input  v-model="product.madeIn" type="text" class="form-control bold" placeholder="" id ="madeIn">
          </div>
          </div>
          

          </div>

      </div>
      </div>

     <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    <button type="submit" :disabled="bt_spinner" class="btn btn-primary float-right mt-1 mb-1 mr-3">
     
      <i class="fas fa-chevron-circle-right mr-2" aria-hidden="true"></i>      
     SALVA E PROCEDI
        <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
    </button> 
           
    </form>
  </div> 
  </div> 
  <!-- COL -->
  </div>

  


  <!-- ROW -->
  </div>
</div>

<div v-else-if="type=='C'">

  <button @click="type='A'" class="btn btn-secondary btn-block mb-1">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                    RITORNA A REGISTRAZIONE PRODOTTO
  </button>    
  <category v-bind:document="true"></category>

</div>  


<div v-else>
  <find-product v-bind:supplierId="doc.supplierId" @update="setProduct"></find-product>
</div>  
  
    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
    </confirm-box>  



  <!-- MAIN DIV -->
  </div>    

</template>
<script>



import api                   from '@/api'
import supplierSelect        from '@/components/common/SupplierSelect.vue' 
import supplierBrandSelect   from '@/components/common/SupplierBrandSelect.vue'

//import categorySelect        from '@/components/common/CategorySelect.vue'

import lineSelect            from '@/components/common/LineSelect.vue'
import seasonSelect          from '@/components/common/SeasonSelect.vue'
import departmentSelect      from '@/components/common/DepartmentSelect.vue'
import yearSelect            from '@/components/common/YearSelect.vue'
import lineModal             from '@/components/common/LineModal.vue'
import findProduct           from '@/components/product/FindProduct.vue'
import alertBox              from '@/components/common/AlertBox.vue'
import confirmBox            from '@/components/common/ConfirmBox.vue'
import category              from '@/components/category/Category.vue'
import checkProduct          from '@/components/product/CheckIfProductIsCreated.vue'
import categoryVueSelect     from '@/components/common/CategoryVueSelect.vue'

import { mapGetters }        from 'vuex';


export default { 
  
  

  props : {_product : Object,doc : Object,productsDoc : Array},
  components: {supplierSelect,supplierBrandSelect,lineSelect,seasonSelect,departmentSelect,yearSelect,lineModal,findProduct,alertBox,confirmBox,category,checkProduct,categoryVueSelect

  },
  
  data () {
      return {

        type            : 'A',  
        product         : this._product,
        category        : {'Id': this._product.categoryId},
        

        msg             : {
          title : '',
          body  : '',
          type  : 0
        },
        bt_spinner       : false,
        lineKey          : 0,
        
        categoryKey      : 100,
        brandKey         : 200,
        departmentKey    : 300,
        seasonKey        : 400,
        yearKey          : 500,
        cb               : {title : '',msg1 : '',show:false},
        vat              : 0,
        refresh          : 0,
        items            : [],
        btn              : false 
        
       
        }
    },
    computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
    
    
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },

  created()
  {
    
    this.vat = this.company.vat
        
  },
  methods: 
  {

    setNewProduct()
    {

      // FAKE DIV
      this.type = 'C'
      this.sentinel = false

      this.product = {}
      this.product.productId = 0
      this.product.supplierId = this.doc.supplierId
      this.product.barcodes = []
      this.product.counter = 0 
      this.product.vat = this.company.vat

      
      this.category.Id = ''
      
      

      this.$nextTick(function () {
        this.type = 'A'
      })
      
      
    },
    
    setProduct(product)
    { 
      
      console.log(product)
      $('#checkProduct-modal-lg').modal('hide');
      if(product.productId == 0 )
      {
        this.setNewProduct()
      }
      else
      {
        this.product     = product  
        this.product.vat = this.vat 
        this.category.Id = product.categoryId
      }
      this.type = 'A'

    },
    refreshLine()
    {
      $('#lineModal').modal('hide');
      this.lineKey++
    },
    setBrand(brand)
    {
      this.product.brand = brand
    },
    setLine(lineId)
    {      
      this.product.lineId = lineId
    },
    setCategoryId(categoryId)
    {
      this.product.categoryId = categoryId
    },
    
    setDepartment(departmentId)
    {
      this.product.departmentId = departmentId
    },
    setSeason(seasonId,e)
    {
      
      this.product.seasonId = seasonId
      
      if(e.target.options.selectedIndex>-1)
      {
        this.product.season = e.target.options[e.target.options.selectedIndex].text
        
      }

    },
    setYear(year)
    {
      this.product.season_year = year
    },
    lineModal()
    {
      $('#lineModal').on('shown.bs.modal', function (e) {
        $('#inputLine').val('');
        $('#inputLine').trigger('focus');
      })
      $('#lineModal').modal({keyboard: false,backdrop:'static'});
    },

    async submit() 
      {
        
        // NEW PRODUCT      
        if(this.product.productId==0)
        {                    
          this.msg.title = ''
          this.bt_spinner = true   

          var isProductCreated = await this.isProductCreated(this.product.sku,this.product.seasonId,this.product.season_year)
          this.bt_spinner = false

          if(isProductCreated.status == 'OK')
          {
            if(isProductCreated.data)
            {
             
              /*
              this.cb.title = "ATTENZIONE "
              this.cb.msg1  = "Prodotto con codice  " + this.product.sku +  ' ' + this.product.season + ' ' + this.product.season_year  + '   già esistente.'
              this.cb.show  = true
              */

              this.items = isProductCreated.items
              this.btn = this.items[1].length>0
             
              this.refresh++
              this.$nextTick(() => {
                $('#checkProduct-modal-lg').modal({keyboard: false,backdrop:'static','show':true});
            
              })
              return 
            }
          }
          else 
          {
            this.cb.title = "ATTENZIONE "
            this.cb.body  = isProductCreated.data
            this.cb.type  = 1  
            return
          }

          this.createProduct()

        }
        else
        {

          // CHECK DOCUMENT > PRODUCT
          let checkProduct = this.productsDoc.filter(item => item.productId == this.product.productId)
          if(checkProduct.length > 0)
          {
            this.cb.title = 'ATTENZIONE '
            this.cb.msg1 = 'PRODOTTO GIA\' PRESENTE SUL DOCUMENTO.'
            this.cb.show = true
            return

          }
          
          this.updateProduct()
          //this.$emit('update',this.product)   
        }
        
        
        
      },

      isProductCreated(sku,seasonId,season_year)
      {
        
        const data      = {'product' : sku, 'supplierId' : this.doc.supplierId,'companyId':this.company.Id,'seasonId':seasonId,'season_year':season_year}
        //var sp        = {'sp' : 'spIsProductCreated'}
        const sp        = {'sp' : 'spCheckIfProductIsCreated'}
        const json      = Object.assign(data, sp);

         return new Promise( async (resolve, reject)  =>  {

         await api.post(json).then(res => {
          if(res.status==200)
            {
              

              resolve({'status':'OK','data': res.data.recordsets[0].length > 0,'items':res.data.recordsets})                
            }
            else if(res.status==500)
            {
                             
               resolve({'status':'Err','data': res.data})       
            } 
            else
            {
              
              resolve({'status':'Err','data': res})       
              
            } 
        }).catch(err => 
        {
          

          resolve({'status':'Err','data': err.message})       
           

        }).finally(() => {
          
        });   


         })  

      },

     
    
    async createProduct()
    {
        this.bt_spinner = true
        var create_at  = new Date()   
        
        var item = 
        {
        'supplierId'  : this.doc.supplierId,   
        'sku'         : this.product.sku, 
        'brand'       : this.product.brand,
        'categoryId'  : this.product.categoryId,
        'create_at'   : create_at,
        'departmentId': this.product.departmentId,
        'seasonId'    : this.product.seasonId,
        'season_year' : this.product.season_year,
        'lineId'      : this.product.lineId ? this.product.lineId : 0,
        'description' : this.product.description ? this.product.description : '', 
        'productId'   : this.product.productId,
        'material'    : this.product.material ? this.product.material : '',
        'dimension'   : this.product.dimension ? this.product.dimension : '',
        'madeIn'      : this.product.madeIn ? this.product.madeIn : '',
        'companyId'   : this.company.Id
        }
        

        var sp        = {'sp' : 'spCreateProduct'}
        var json      = Object.assign(item, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
                this.product.productId = res.data.recordsets[0][0].id
                this.product.counter = 1
                this.product.barcodes = []
                this.$emit('update',this.product)              
            }
            else if(res.status==500)
            {
              

              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    

            } 
            else
            {
              
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
               
            } 
        }).catch(err => 
        {
          
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            
        }).finally(() => {
          this.bt_spinner = false
        });

      
    },
    async updateProduct()
    {
        this.bt_spinner = true
        var create_at  = new Date()   
        
        var item = 
        {
        'supplierId'  : this.doc.supplierId,   
        'sku'         : this.product.sku, 
        'brand'       : this.product.brand,
        'categoryId'  : this.product.categoryId,
        'update_at'   : create_at,
        'departmentId': this.product.departmentId,
        'seasonId'    : this.product.seasonId,
        'season_year' : this.product.season_year,
        'lineId'      : this.product.lineId ? this.product.lineId : 0,
        'description' : this.product.description ? this.product.description : '', 
        'productId'   : this.product.productId,
        'material'    : this.product.material ? this.product.material : '',
        'dimension'   : this.product.dimension ? this.product.dimension : '',
        'madeIn'      : this.product.madeIn ? this.product.madeIn : '',
        'companyId'   : this.company.Id
        }
        

        var sp        = {'sp' : 'spUpdateProduct'}
        var json      = Object.assign(item, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
                this.$emit('update',this.product)              
            }
            else if(res.status==500)
            {
              

              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    

            } 
            else
            {
              
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
               
            } 
        }).catch(err => 
        {
          
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            
        }).finally(() => {
          this.bt_spinner = false
        });

      
    },  
  



    
    }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn_1
{
  font-family      : 'Roboto Condensed';
  background-color : khaki;
  color            : black
}
.btn_2
{
  font-family      : 'Roboto Condensed';
  background-color :  khaki;
  color            : black
}


label,i,span:hover {
   
   cursor    : pointer 
   
}
span{
  font-family: 'Roboto Condensed';
}

label{
  color:black
  
}
.bold {
font-weight: bolder;
}

/*input {border-color: coral;}*/

.form-text {
  color : red
}
/*
.is-flex {
  display: flex;
  flex-wrap: wrap;
}
*/

/*
.is-flex>[class*='col-'] {
  display: flex;
  flex-direction: column;
}
*/
/*
.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
*/

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.card-header{
  background-color:  rgb(209, 234, 206);  
  
}
</style>
